module.exports = __webpack_public_path__ + "img/share_coupon_icon.597ebf8d.jpg";